import { useState } from "react";
import eventImage from "../../assets/images/kinangop1.jpg"
import Hero, { HeroType } from "../../components/hero/hero.component"
import "./programme.styles.scss"
import EventDescription, { DESCRIPTION_TYPE } from "../../components/eventDescription/eventDescription.component";
import Footer from "../../components/footer/footer.component";
import Timeline from "../../components/timeline/timeline.component";

const Programme = () => {
    const [ activeItem, setActiveItem ] = useState(1);
    const [ descriptionType, setDescriptionType ] = useState(DESCRIPTION_TYPE.base);

    const handleDescriptionClick = (type, index) => {
        setDescriptionType(type)
        setActiveItem(index)
    }
    return (
        <>
        <Hero
            headerPrimary={"Quest For mount kenya"}
            headerSecondary={"in 90 Days"}
            heroType={HeroType.DetailPage}
            backgroundImage={eventImage}
        />
        <div className="programme">
            <div className="programme__introduction u-margin-bottom-small">
                <h2 className="header__secondary--sub u-margin-bottom-tiny">A beginner guide to mount kenya</h2>
                <p className="u-margin-bottom-small">
                    We started our program with a simple yet powerful idea: make the extraordinary achievable for ordinary hikers.
                    Our 90-day journey to conquer Mt Kenya is more than just a trek; it's a transformative experience designed for individuals 
                    seeking adventure and personal growth. Immerse yourself in the beauty of three to six high-altitude hikes in the Aberdares, 
                    meticulously planned to prepare you for the ultimate summit. You also get to experience two different routes during the Mt Kenya climb.
                </p>
                <ul className="programme__introduction-list">
                    <li><b>Duration:</b> 90 days</li>
                    <li><b>Start Date:</b> 20 th June 2024</li>
                    <li><b>End Date:</b> 5th sep 2024</li>
                    <li><b>Total Hikes:</b> 6, two every month</li>
                </ul>
            </div>
            <div className="programme__roadmap">
                <h2 className="header__secondary--sub u-margin-bottom-small">Programme Roadmap</h2>
                <div className="u-margin-bottom-medium">
                    <Timeline />
                </div>
            </div>
            <div className="event-details__description u-margin-bottom-small">
                <div className="event-details__description-header u-margin-bottom-small">
                    <ul>
                        <li 
                            className={activeItem === 1 ? 'event-details__description-header--highlighted' : ''}
                            onClick= {() => handleDescriptionClick(DESCRIPTION_TYPE.price, 1)}
                        >
                            Pricing
                        </li>
                        <li 
                            className={activeItem === 2 ? 'event-details__description-header--highlighted' : ''}
                            onClick= {() => handleDescriptionClick(DESCRIPTION_TYPE.list, 2)}
                        >Gear CheckList</li>
                        <li 
                            className={activeItem === 3 ? 'event-details__description-header--highlighted' : ''}
                            onClick= {() => handleDescriptionClick(DESCRIPTION_TYPE.list, 3)}
                        >Cancellation Policy</li>
                    </ul>
                </div>
                <div className="event-details__description-content">
                    <EventDescription type={descriptionType}/>
                </div>
            </div>
        </div>
        <div className="u-footer-height">
            <Footer/>
        </div>
        </>
    )
}

export default Programme;